export default "__VITE_ASSET__5bc8270f__"